import ModuleHome from "@/components/modules/ModuleHome.vue";
import ModuleUsers from "@/components/modules/ModuleUsers.vue";
import EntityUser from "@/components/entities/EntityUser.vue";
import ModuleClients from "@/components/modules/ModuleClients.vue";
import EntityClient from "@/components/entities/EntityClient.vue";
import ModuleRegistrations from "@/components/modules/ModuleRegistrations.vue";
import EntityRegistration from "@/components/entities/EntityRegistration.vue";

export default [
    {path: '/', component: ModuleHome},
    {path: '/users', component: ModuleUsers},
    {path: '/users/:id', component: EntityUser},
    {path: '/clients', component: ModuleClients},
    {path: '/clients/:id', component: EntityClient},
    {path: '/registrations', component: ModuleRegistrations},
    {path: '/registrations/:id', component: EntityRegistration}
]